
import * as commonConst from '../common/constants';
import * as snapStrategyConst from './constants';
import * as snapStrategyApis from '../../services/apis/snapstrategy';
import * as commonRegionService from '../../services/common/region';

export default {
    //查询自动快照策略
    [snapStrategyConst.getSnapStrategy] (ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, snapStrategyApis.getSnapStrategyList);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                
                if(data.msg) {
                    reject(data.msg)
                } else {
                    ctx.commit(snapStrategyConst.getSnapStrategy, data);
                    resolve(data);
                }
            }).catch(e => {
                reject(e);
            })
        });
    },
    //创建自动快照策略
    [snapStrategyConst.createSnapStra] (ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, snapStrategyApis.createSnapStra);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    },
    //修改自动快照策略
    [snapStrategyConst.modifyStrategy] (ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, snapStrategyApis.modifyStrategy);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                // ctx.commit(snapStrategyConst.modifyStrategy, data);
                
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    },
    //删除自动快照策略
    [snapStrategyConst.deleteStrategy] (ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, snapStrategyApis.deleteStrategy);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    },
    //执行自动快照策略
    [snapStrategyConst.applyStrategy] (ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, snapStrategyApis.applyStrategy);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    },  
    //取消执行自动快照策略
    [snapStrategyConst.cancelStrategy] (ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, snapStrategyApis.cancelStrategy);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    },
    //设置硬盘策略
    [snapStrategyConst.bindStrategy] (ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, snapStrategyApis.bindStrategy);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    },
    //获取服务器时间
    [snapStrategyConst.getnextSnapTime] (ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, snapStrategyApis.getnextSnapTime);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    },
    //自动快照白名单校验
    [snapStrategyConst.validateSnapStra] (ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge({params: params}, snapStrategyApis.validateSnapStra);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                ctx.commit(snapStrategyConst.validateSnapStra,data)
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    },
    //目前只在自动快照策略里 白名单验证 因为返回值不一样，Mainview里面也会调白名单验证，不确定谁会先返回，所以新增一个
    [snapStrategyConst.validateEbsAndLocalSnapStra] (ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(snapStrategyApis.validateEbsAndLocalSnapStra,{params: params});
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    },
    //获取策略数量
    [snapStrategyConst.GetAutoSnapshotQuota] (ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, snapStrategyApis.GetAutoSnapshotQuota);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    },
};
